var Common = (function() {
    const IMG_SRC_BTN_CHECK_ON = "/images/new/btn_check_on.png";
    const IMG_SRC_BTN_CHECK_OFF = "/images/new/btn_check_off.png";

    // 체크 아이콘 On / Off
    function checkIcon($iconDiv) {
        var currentState = $iconDiv.data("checked");
        var $imgSrc = $iconDiv.find("img");
        !currentState
            ? $imgSrc.attr("src", IMG_SRC_BTN_CHECK_ON)
            : $imgSrc.attr("src", IMG_SRC_BTN_CHECK_OFF);
        currentState = !currentState;
        $iconDiv.data("checked", currentState);
    }

    function serializeObject ($form) {
        var o = {};
        var a = $form.serializeArray();
        $.each(a, function() {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || "");
            } else {
                o[this.name] = this.value || "";
            }
        });
        return o;
    };

    function getFormData($form) {
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function(n, i) {
            indexed_array[n["name"]] = n["value"];
        });

        return indexed_array;
    }

    return { checkIcon, serializeObject };
})();

export default Common;



// WEBPACK FOOTER //
// ./js/waglebagle/common.js